import image_one from "../assets/images/1.png";
import image_two from "../assets/images/2.png";
import image_three from "../assets/images/3.png";
import image_four from "../assets/images/4.png";
import image_five from "../assets/images/5.png";
import image_six from "../assets/images/6.png";
import image_seven from "../assets/images/7.png";
import image_eight from "../assets/images/8.png";
import image_nine from "../assets/images/9.png";

const images = [
  { id: 1, key: 1, src: image_one },
  { id: 2, key: 2, src: image_two },
  { id: 3, key: 3, src: image_three },
  { id: 4, key: 4, src: image_four },
  { id: 5, key: 5, src: image_five },
  { id: 6, key: 6, src: image_six },
  { id: 7, key: 7, src: image_seven },
  { id: 8, key: 8, src: image_eight },
  { id: 9, key: 9, src: image_nine },
];

const shuffleArray = (array: Array<any>) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const getCards = () => {
  const dupplicationArray = [
    ...images,
    ...images.map((image) => ({
      ...image,
      key: image.key + images.length,
    })),
  ].map((card) => ({ ...card, isFlipping: true, isFinished: false }));
  return shuffleArray(dupplicationArray);
};
